import { Container, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router-dom';
import { useSpinner } from '../context';
import { isVersionMismatchError, shouldAttemptReload } from '../lib/ErrorBoundaryHelper';

/**
 * should used on the Basic System Route Group
 */
export function ErrorBoundary() {
  const { pathname } = useLocation();
  const error = useRouteError();
  const { setLoading } = useSpinner();

  const isVersionError = error instanceof Error && isVersionMismatchError(error);
  const allowReload = isVersionError && shouldAttemptReload();

  useEffect(() => {
    if (allowReload) {
      setLoading(true);
      window.location.reload();
    }
  }, [allowReload, pathname]);

  if (isVersionError && !allowReload) {
    return (
      <Container maxWidth="md" sx={{ textAlign: 'center', mt: 8 }}>
        <Typography variant="h2" gutterBottom>
          500 - ネットワークエラーが発生しました。
        </Typography>
        <Typography variant="h5" gutterBottom>
          ネットワーク接続を確認の上、再試行してください。問題が解決しない場合は、管理者にご連絡ください。
        </Typography>
      </Container>
    );
  }

  if (isVersionError && allowReload) {
    return (
      <Container maxWidth="md" sx={{ textAlign: 'center', mt: 8 }}>
        <Typography variant="h2" gutterBottom>
          500 - ネットワークエラーが発生しました。
        </Typography>
        <Typography variant="h5" gutterBottom>
          ページを再読み込みしてください。問題が解決しない場合は、管理者にご連絡ください。
        </Typography>
      </Container>
    );
  }

  return null;
}
